
        var result = require("!!../../../../node_modules/css-loader/index.js!./ploeginfo.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/ploeginfo/ploeginfo.component.css
// module id = 625
// module chunks = 0